import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux'; // import { Link } from 'react-router-dom'

import Applet from './Applet';
import dateFnsParseISO from 'date-fns/parseISO';
import dateFnsFormat from 'date-fns/format';
import { getSingleUser } from 'store/slices/personalSlice';

const Overview = ({
  user,
  getSingleUser,
  connections
}) => {
  const {
    t
  } = useTranslation();
  // Extract the complex expression to a separate variable
  const userId = user?.objectId;
  useEffect(() => {
    if (user && user.objectId) {
      getSingleUser(user.objectId);
    }
  }, [getSingleUser, user, userId]); // Add debugging to see what user data we're receiving

  console.log('Overview user data:', user);
  console.log('Overview user.createdAt:', user?.createdAt);
  console.log('Overview user.createdAt type:', typeof user?.createdAt);
  console.log('Overview user.primaryEmail:', user?.primaryEmail);
  const signUpDate = useMemo(() => {
    if (!user || !user.createdAt) {
      console.log('No user or createdAt, using fallback date');
      return new Date(); // Fallback to current date
    } // Handle different date formats


    if (typeof user.createdAt === 'string') {
      try {
        return dateFnsParseISO(user.createdAt);
      } catch (error) {
        console.log('Failed to parse createdAt string:', user.createdAt, error);
        return new Date(); // Fallback to current date
      }
    } else if (typeof user.createdAt === 'number') {
      // Handle timestamp
      return new Date(user.createdAt);
    } else {
      console.log('Unknown createdAt format:', user.createdAt);
      return new Date(); // Fallback to current date
    }
  }, [user]); // Safely get the primary email value

  const getPrimaryEmailValue = () => {
    if (!user) return 'No user data'; // Try different possible structures

    if (user.email) {
      return user.email;
    }

    if (user.primaryEmail && user.primaryEmail.parameters && user.primaryEmail.parameters[1] && user.primaryEmail.parameters[1].value) {
      return user.primaryEmail.parameters[1].value;
    }

    if (user.primaryEmail && user.primaryEmail.value) {
      return user.primaryEmail.value;
    }

    return 'Email not available';
  };

  const activeConnections = connections && connections.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).filter((conn, i) => conn.status === 'connected' && i < 5);
  const title = `${t("Account Overview -  member since")} ${dateFnsFormat(signUpDate, 'PP')}`;
  return <Applet title={title} size={6}>
      <p>{t("Primary login:")}<strong>{getPrimaryEmailValue()}</strong></p>
      {activeConnections && activeConnections.length > 0 ? <p>{t("I have")}<strong>{activeConnections && activeConnections.length && activeConnections.length}</strong>{t("Connection")}{activeConnections && activeConnections.length !== 1 ? 's' : ''}.</p> : activeConnections && activeConnections.length === 0 ? t('I have 0 connections') : ''}

      {activeConnections && activeConnections.length > 0 ? <p>{t("My recent connections:")}</p> : ''}
      <ol>{activeConnections && activeConnections.map(({
        objectId,
        fullName,
        email,
        createdAt
      }) => {
        const isodate = dateFnsParseISO(createdAt);
        const date = `${dateFnsFormat(isodate, 'PP')}`;
        return <li key={objectId}><strong>{fullName || email}</strong>{t("- connected")}{date}</li>;
      })}
      </ol>
      <hr />
      <p>{t("Use our mobile app to manage connections and see your invitations.")}</p>
    </Applet>;
};

const mapStateToProps = state => ({
  user: state.auth.currentUser,
  connections: state.auth.connections.outgoing
});

const mapDispatchToProps = dispatch => ({
  getSingleUser: user => dispatch(getSingleUser(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Overview);